import { call, cancel, fork, put, takeEvery } from "redux-saga/effects"
import {
  GET_AGREEMENT_SELECTION,
  storeCircusAgreement,
  storePersonalRelationCardIsDisplay,
  storeAdvertisingAgreement,
  storeAdvertisingCardIsDisplay,
  storeThirdPartyCardIsDisplay,
  storeTimeoutModalIsOpen,
} from "actions"
import { getAdvertisingAgreement } from "apis/AdvertisingAgreement"
import { getCircusAgreement } from "apis/CircusAgreement"
import { execTimeoutTimer } from "sagas/Timeout"

import history from "govHistory"
import { callApi } from "sagas/Api"

export function* handleGetAgreementSelection() {
  yield takeEvery(GET_AGREEMENT_SELECTION, execGetAgreementSelection)
}

export function* execGetAgreementSelection() {
  let result = null
  // 表示フラグ
  let personalRelationCardIsDisplay = false
  let advertisingCardIsDisplay = false
  let thirdPartyCardIsDisplay = false
  const { pathname } = document.location

  // API実行開始後に指定の秒数が経過後、タイムアウト処理を実行する
  const timeout = yield fork(execTimeoutTimer)

  result = yield call(callApi, getCircusAgreement)
  if (!result.payload || result.error) {
    yield cancel(timeout)
    yield put(storeTimeoutModalIsOpen(false))
  }
  if (result.payload && !result.error) {
    yield put(storeCircusAgreement(result.payload))
    // 表示フラグを取得
    personalRelationCardIsDisplay =
      Number(result.payload.personalRelationAgree) === 0
    thirdPartyCardIsDisplay =
      Number(result.payload.thirdpartyAgreeBasicCorp) === 0 &&
      Number(result.payload.thirdpartyAgreeHealthDpt) === 0 &&
      Number(result.payload.thirdpartyAgreeHealthCorp) === 0
  } else {
    // トークンリフレッシュに失敗するパターンは画面遷移がないと起こりえないので、下記の処理に統一する
    yield call(history.push, "/error", { pathname })
    return
  }

  result = null
  result = yield call(callApi, getAdvertisingAgreement)

  yield cancel(timeout)
  yield put(storeTimeoutModalIsOpen(false))

  if (result.payload && !result.error) {
    yield put(storeAdvertisingAgreement(result.payload))

    // 表示フラグを取得
    // ステータス拒否の場合もカードを表示する
    advertisingCardIsDisplay =
      result.payload.advertisingAgree === 0 ||
      Math.floor(result.payload.advertisingAgree / 100) === 2
  } else {
    // トークンリフレッシュに失敗するパターンは画面遷移がないと起こりえないので、下記の処理に統一する
    yield call(history.push, "/error", { pathname })
    return
  }

  // 表示するものがない（すべて同意されている）場合はありがとうページに飛ばす
  if (
    !personalRelationCardIsDisplay &&
    !advertisingCardIsDisplay &&
    !thirdPartyCardIsDisplay
  ) {
    yield call(history.push, "/thanks", { pathname })
    return
  }

  yield call(history.push, "/")
  yield put(storePersonalRelationCardIsDisplay(personalRelationCardIsDisplay))
  yield put(storeAdvertisingCardIsDisplay(advertisingCardIsDisplay))
  yield put(storeThirdPartyCardIsDisplay(thirdPartyCardIsDisplay))
  return
}
